"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Svg16BrowseLine = function Svg16BrowseLine(_ref) {
  var fill = _ref.fill,
      useDefaultColors = _ref.useDefaultColors,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "useDefaultColors", "title"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: useDefaultColors ? 'none' : fill,
    "aria-hidden": title === null || typeof title !== 'string' || title.length === 0
  }, props), _react.default.createElement("title", null, title), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.47 9.743a1 1 0 0 0-1.213-1.213l-4 1a1 1 0 0 0-.727.728l-1 4a1 1 0 0 0 1.213 1.212l4-1a1 1 0 0 0 .727-.728l1-4zM11.28 11.5h1.22v1.22l-1.626.406.407-1.626z",
    fill: useDefaultColors ? '#191919' : fill
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-2a6 6 0 1 0 0-12 6 6 0 0 0 0 12z",
    fill: useDefaultColors ? '#191919' : fill
  }));
};

Svg16BrowseLine.propTypes = {
  title: _propTypes.default.string,
  fill: _propTypes.default.string,
  useDefaultColors: _propTypes.default.bool
};
var _default = Svg16BrowseLine;
exports.default = _default;